import dayjs from 'dayjs';
import { upperFirst } from 'lodash';

import { OfferCategory, Reservation } from '../../../graphql/API';
import { getDateAndTimeInTimezoneInDayjs } from '../../../utils/dateV2';
import { formatName } from '../../../utils/user';

const mapToCsv = (d: Reservation) => ({
  Name: formatName(d.user ?? undefined),
  Offer: d.offerTitle,
  Collab: d.privateOffer ? 'Collab' : '-',
  'Reservation Date': dayjs(d.createdAt).format('LL'),
  Status: upperFirst(d.status),
  Posted: d.postLink || '',
});

export const mapToCsvForOnlineBrand = (d: Reservation) => ({
  Product: d.offerTitle,
  'First Name': d.user?.firstname,
  'Last Name': d.user?.lastname,
  Country: d.shippingAddress?.country || '',
  'Address 1': d.shippingAddress?.address1 || '',
  'Address 2': d.shippingAddress?.address2 || '',
  City: d.shippingAddress?.city || '',
  'State Or Province': d.shippingAddress?.stateProvince || '',
  'Postal Code': d.shippingAddress?.postalCode || '',
  'Reservation date': getDateAndTimeInTimezoneInDayjs(
    d?.effectiveStartDateTime as string,
    d?.offerCategory === OfferCategory.event && d?.offerTimeZoneId ? d?.offerTimeZoneId : d?.timeZoneId,
  )?.format('LL'),
  'Shipping Status': upperFirst(d.shippingStatus || ''),
  'Shipping Date': getDateAndTimeInTimezoneInDayjs(d?.shippedDate as string, d?.timeZoneId)?.format(
    'LL',
  ),
  Posted: d.postLink || '',
});

export default mapToCsv;
